import { render, staticRenderFns } from "./afterSales.vue?vue&type=template&id=c06334b2&scoped=true&"
var script = {}
import style0 from "./afterSales.vue?vue&type=style&index=0&id=c06334b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06334b2",
  null
  
)

export default component.exports